/** Document file names: `.zwdoc`, or a legacy Markdown name before conversion. */
const DOCUMENT_EXT = /\.(zwdoc|md|markdown|mdown)$/i;
const MAP_EXT = /\.zwmap$/i;

/** Extension for new documents (#259). */
export const DOCUMENT_EXTENSION = ".zwdoc";

/** Display label for a project path or basename — drop known extensions. */
export function displayFileName(name: string): string {
  const base = name.replace(/^.*[/\\]/, "");
  const stripped = base.replace(DOCUMENT_EXT, "").replace(MAP_EXT, "");
  return stripped.length > 0 ? stripped : base;
}

export function hasDocumentExtension(name: string): boolean {
  return DOCUMENT_EXT.test(name);
}

/** `name` as a document file name (`Idea` → `Idea.zwdoc`; extensions kept). */
export function documentFileName(name: string): string {
  return hasDocumentExtension(name) ? name : `${name}${DOCUMENT_EXTENSION}`;
}

/** `name` without its document extension. */
export function stripDocumentExtension(name: string): string {
  return name.replace(DOCUMENT_EXT, "");
}

export function hasMapExtension(name: string): boolean {
  return MAP_EXT.test(name);
}
